import React from "react";
import { Table, Input, Button } from "reactstrap";
import { FormattedMessage, useIntl } from "react-intl";
import { saveAs } from "file-saver";
import TablePagination from "./TablePagination";
import { useTableControls } from "./useTableControls";

const PAGE_SIZE_OPTIONS = [25, 50, 100];
const SEARCHABLE_FIELDS = [
  "courseName",
  "moduleName",
  "gradeAverage",
  "numberOfGrades",
];

export default function ModuleRatingsTable({
  ratingsResponse,
  avgRating,
  totRatings,
}) {
  const intl = useIntl();
  const {
    pageRows,
    searchQuery,
    handleSearchChange,
    sortByColumn,
    sortIndicator,
    pagination,
  } = useTableControls(ratingsResponse, SEARCHABLE_FIELDS, 50);

  const fnExcelReport = () => {
    var tab_text =
      "<table>" +
      "<tr>" +
      "<th>Kurs</th>" +
      "<th>Modul</th>" +
      "<th>Genomsnittligt betyg</th>" +
      "<th>Antal betyg</th>" +
      "</tr>";
    ratingsResponse.forEach((ratings) => {
      tab_text +=
        "<tr>" +
        "<td>" +
        ratings.courseName +
        "</td><td>" +
        ratings.moduleName +
        "</td><td>" +
        ratings.gradeAverage +
        "</td><td>" +
        ratings.numberOfGrades +
        "</td>" +
        "</tr>";
    });
    tab_text = tab_text + "</table>";
    var data = new Blob(["\ufeff", tab_text], {
      type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;charset=utf-8",
      encoding: "utf-8",
    });
    saveAs(data, "Modulbetyg.xls");
  };

  return (
    <div className="container-fluid admin-container">
      <Table>
        <thead>
          <tr>
            <th>Totalt genomsnittligt betyg: {avgRating}</th>
            <th>Totalt antal betyg: {totRatings}</th>
          </tr>
        </thead>
      </Table>
      <Button className="mb-2" outline color="primary" onClick={fnExcelReport}>
        <FormattedMessage id="ExportToXls" />
      </Button>
      <Input
        type="text"
        className="mb-2"
        value={searchQuery}
        onChange={handleSearchChange}
        placeholder={intl.formatMessage({ id: "Search" })}
      />
      <Table hover className="table table-striped clickable" id="grades-table">
        <thead>
          <tr>
            <th onClick={() => sortByColumn("courseName")}>
              Kurs{sortIndicator("courseName")}
            </th>
            <th onClick={() => sortByColumn("moduleName")}>
              Modul{sortIndicator("moduleName")}
            </th>
            <th onClick={() => sortByColumn("gradeAverage")}>
              Genomsnittligt betyg{sortIndicator("gradeAverage")}
            </th>
            <th
              className="text-end"
              onClick={() => sortByColumn("numberOfGrades")}
            >
              Antal betyg{sortIndicator("numberOfGrades")}
            </th>
          </tr>
        </thead>
        <tbody>
          {pageRows.map((ratings) => (
            <tr
              style={{ cursor: "text" }}
              key={`${ratings.courseId}-${ratings.moduleId}`}
            >
              <td>{ratings.courseName}</td>
              <td>{ratings.moduleName}</td>
              <td>{ratings.gradeAverage}</td>
              <td className="text-end">{ratings.numberOfGrades}</td>
            </tr>
          ))}
        </tbody>
      </Table>
      <TablePagination {...pagination} pageSizeOptions={PAGE_SIZE_OPTIONS} />
    </div>
  );
}
